"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @description Gestion du comportement du bloc "démarches rapides"
 */

/* global bsBreakpoints */
(function () {
  // VARIABLES
  var demarchesBloc = document.querySelector('.services__demarches');
  var demarchesButton = demarchesBloc.querySelector('.demarches__open-button');
  var demarchesClose = demarchesBloc.querySelector('.demarches__close-button');
  var demarchesLink = document.querySelector('.demarches__link') || null;

  var navKeyboard = function navKeyboard() {
    demarchesBloc.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        demarchesBloc.classList.add('services__demarches--keyboard');
        demarchesButton.setAttribute('aria-expanded', true);
      } else if (e.key === 'Escape') {
        demarchesBloc.classList.remove('services__demarches--keyboard');
        demarchesButton.setAttribute('aria-expanded', false);
      }
    });
    demarchesBloc.addEventListener('mouseover', function (e) {
      demarchesBloc.classList.remove('services__demarches--a11y');
      demarchesBloc.setAttribute('tabindex', '-1');
      demarchesBloc.focus();
      var prevEl = demarchesBloc.previousElementSibling;
      var nextEl = demarchesBloc.nextElementSibling;

      var keyboardNextElement = _toConsumableArray(nextEl.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden');
      });

      var keyboardPrevElement = _toConsumableArray(prevEl.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden');
      });

      demarchesBloc.addEventListener('keydown', function (e) {
        e.preventDefault();

        if (e.key === 'Escape') {
          demarchesBloc.classList.add('services__demarches--a11y');
          keyboardNextElement[0].focus();
        }

        if (e.key === 'Enter') {
          demarchesBloc.classList.remove('services__demarches--a11y');
        }

        if (e.keyCode === 9) {
          if (e.shiftKey) {
            keyboardPrevElement[0].focus();
          } else {
            keyboardNextElement[0].focus();
          }
        }
      });
    });

    if (demarchesLink) {
      demarchesLink.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          demarchesBloc.classList.remove('services__demarches--keyboard');
          demarchesButton.setAttribute('aria-expanded', false);
        }
      });
    }
  }; // FONCTIONS
  // Menu responsive


  var demarchesRwd = function demarchesRwd() {
    if (bsBreakpoints.detectBreakpoint() === 'xSmall' || bsBreakpoints.detectBreakpoint() === 'small' || bsBreakpoints.detectBreakpoint() === 'medium') {
      demarchesButton.addEventListener('click', function () {
        demarchesBloc.classList.add('active');
        demarchesButton.tabIndex = -1;
        keyboardNavigation(document.querySelector('.services__demarches.active'));
        demarchesBloc.querySelector('.demarches__open-button').setAttribute('aria-expanded', 'true');
      });
    }
  };

  var keyboardNavigation = function keyboardNavigation(e) {
    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    var firstFocusableElement = e.querySelectorAll(focusableElements)[0]; // get first element to be focused inside bloc

    var focusableContent = e.querySelectorAll(focusableElements);
    var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside bloc

    document.addEventListener('keydown', function (e) {
      var isTabPressed = e.key === 'Tab';

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element

          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element

          e.preventDefault();
        }
      }
    });
    firstFocusableElement.focus();
  };

  var outsideClick = function outsideClick(event, notelem) {
    // check outside click for multiple elements
    var clickedOut = true;
    var i;
    var len = notelem.length;

    for (i = 0; i < len; i++) {
      if (event.target === notelem[i] || notelem[i].contains(event.target)) {
        clickedOut = false;
      }
    }

    if (clickedOut) return true;else return false;
  }; // Ferme le bloc démarches rapides


  var demarchesRwdClose = function demarchesRwdClose() {
    demarchesClose.addEventListener('click', function () {
      demarchesBloc.classList.remove('services__demarches--keyboard', 'active');
      demarchesButton.tabIndex = 0;
      demarchesButton.setAttribute('aria-expanded', false);
    });
    document.addEventListener('click', function (e) {
      if (outsideClick(e, [demarchesBloc, demarchesButton])) {
        demarchesBloc.classList.remove('services__demarches--keyboard', 'active');
        demarchesButton.tabIndex = 0;
        demarchesButton.setAttribute('aria-expanded', false);
      }
    });
  }; // GO 🚀


  var init = function init() {
    window.addEventListener('resize', function () {
      demarchesRwd();
    });
    demarchesRwd();
    demarchesRwdClose();
    navKeyboard();
  };

  init();
})();